const common = {
    vat: 'VAT',
    currency: 'CURRENCY',
    defaultImg: '/storage/default/default.png',

    minPrice: 0,
    maxPrice: 3000,
};

export default common;
